const demoUserProfiles = [
  {
    memberId: "1",
    firstName: "Becky",
    lastName: "Johnson",
    story: `Becky has spent years building financial stability for her family and recently renovated parts of her home. Between rising expenses, several credit cards, and a personal loan from another bank, her monthly payments have started feeling harder to manage. She has strong credit and substantial equity in her home, but she wants a smarter way to consolidate debt and reduce financial stress without disrupting her lifestyle.`,
    lastUpdated: "2026-07-01",
    financialProfile: {
      demographics: {
        age: null,
        ageRange: "",
        maritalStatus: "",
        dependents: 0,
        employmentStatus: "",
        annualIncome: 98000,
        householdIncome: null,
      },
      housing: {
        isHomeOwner: true,
        isRenter: false,
        mortgage: {
          hasMortgage: false,
          balance: null,
          interestRate: null,
          monthlyPayment: null,
          yearsRemaining: null,
        },
        estimatedHomeValue: null,
        equityAmount: 200000,
        equityPercent: null,
        purchaseDate: null,
      },
      vehicles: {
        vehicleCount: 0,
        hasVehicleLoan: false,
        totalVehicleValue: null,
        totalVehicleLoanBalance: null,
        vehicles: [],
      },
      banking: {
        hasChecking: false,
        hasSavings: false,
        hasMoneyMarket: false,
        hasCertificate: false,
        hasDirectDeposit: false,
        monthlyDepositAmount: null,
        averageCheckingBalance: null,
        averageSavingsBalance: null,
        overdraftCountLast12Months: 0,
      },
      credit: {
        creditScore: null,
        creditScoreRange: "",
        creditCardCount: 1,
        creditCardDebt: {
          hasDebt: true,
          totalBalance: 24000,
          estimatedMonthlyPayment: null,
          averageInterestRate: null,
        },
        creditUtilizationPercent: null,
      },
      loans: {
        studentLoans: {
          hasStudentLoans: false,
          balance: null,
          monthlyPayment: null,
        },
        personalLoans: {
          hasPersonalLoans: true,
          balance: 11000,
          monthlyPayment: null,
        },
        otherDebt: {
          balance: null,
          monthlyPayment: null,
        },
      },
      insurance: {
        hasAutoInsurance: false,
        hasHomeInsurance: false,
        hasLifeInsurance: false,
        hasUmbrellaInsurance: false,
      },
      business: {
        isBusinessOwner: false,
        hasBusinessChecking: false,
        hasMerchantServices: false,
      },
      investments: {
        hasIRA: false,
        hasRothIRA: false,
        hasBrokerageAccount: false,
        estimatedInvestableAssets: null,
      },
      education: {
        hasCollegeBoundChildren: false,
        has529Plan: false,
        tuitionPaymentsExpected: false,
      },
      lifeEvents: {
        recentlyMarried: false,
        newChild: false,
        recentHomePurchase: false,
        planningRetirement: false,
        recentJobChange: false,
        recentRelocation: false,
      },
      behavioralIndicators: {
        highSavingsGrowth: false,
        highDepositActivity: false,
        largeRecentWithdrawal: false,
        largeRecentDeposit: false,
        frequentCreditCardUsage: false,
        frequentATMUsage: false,
      },
      financialHealth: {
        debtToIncomeRatio: null,
        emergencyFundMonths: null,
        netWorthEstimate: null,
      },
    },
  },
  {
    memberId: "2",
    firstName: "Madison",
    lastName: "Parker",
    story: `Madison graduated college earlier this year and just celebrated her 22nd birthday yesterday. She's excited to finally start building her career, but the transition into adulthood has been financially overwhelming. Between student loans, apartment expenses, and credit card balances that grew during school, she feels like she's constantly trying to catch up. Lower interest payments and breathing room would help her feel more in control of her future.`,
    lastUpdated: "2026-07-01",
    financialProfile: {
      demographics: {
        age: 22,
        ageRange: "",
        maritalStatus: "",
        dependents: 0,
        employmentStatus: "",
        annualIncome: 47000,
        householdIncome: null,
      },
      housing: {
        isHomeOwner: false,
        isRenter: true,
        mortgage: {
          hasMortgage: false,
          balance: null,
          interestRate: null,
          monthlyPayment: null,
          yearsRemaining: null,
        },
        estimatedHomeValue: null,
        equityAmount: null,
        equityPercent: null,
        purchaseDate: null,
      },
      vehicles: {
        vehicleCount: 0,
        hasVehicleLoan: false,
        totalVehicleValue: null,
        totalVehicleLoanBalance: null,
        vehicles: [],
      },
      banking: {
        hasChecking: false,
        hasSavings: false,
        hasMoneyMarket: false,
        hasCertificate: false,
        hasDirectDeposit: false,
        monthlyDepositAmount: null,
        averageCheckingBalance: null,
        averageSavingsBalance: null,
        overdraftCountLast12Months: 0,
      },
      credit: {
        creditScore: null,
        creditScoreRange: "",
        creditCardCount: 1,
        creditCardDebt: {
          hasDebt: true,
          totalBalance: 9200,
          estimatedMonthlyPayment: null,
          averageInterestRate: null,
        },
        creditUtilizationPercent: null,
      },
      loans: {
        studentLoans: {
          hasStudentLoans: true,
          balance: 38000,
          monthlyPayment: null,
        },
        personalLoans: {
          hasPersonalLoans: false,
          balance: null,
          monthlyPayment: null,
        },
        otherDebt: {
          balance: null,
          monthlyPayment: null,
        },
      },
      insurance: {
        hasAutoInsurance: false,
        hasHomeInsurance: false,
        hasLifeInsurance: false,
        hasUmbrellaInsurance: false,
      },
      business: {
        isBusinessOwner: false,
        hasBusinessChecking: false,
        hasMerchantServices: false,
      },
      investments: {
        hasIRA: false,
        hasRothIRA: false,
        hasBrokerageAccount: false,
        estimatedInvestableAssets: null,
      },
      education: {
        hasCollegeBoundChildren: false,
        has529Plan: false,
        tuitionPaymentsExpected: false,
      },
      lifeEvents: {
        recentlyMarried: false,
        newChild: false,
        recentHomePurchase: false,
        planningRetirement: false,
        recentJobChange: false,
        recentRelocation: false,
      },
      behavioralIndicators: {
        highSavingsGrowth: false,
        highDepositActivity: false,
        largeRecentWithdrawal: false,
        largeRecentDeposit: false,
        frequentCreditCardUsage: false,
        frequentATMUsage: false,
      },
      financialHealth: {
        debtToIncomeRatio: null,
        emergencyFundMonths: null,
        netWorthEstimate: null,
      },
    },
  },
  {
    memberId: "3",
    firstName: "Frank",
    lastName: "Miller",
    story: `Frank has spent decades working hard and preparing for retirement while supporting his family. He and his wife will celebrate their 40th anniversary next month, and they have always loved traveling to Hawaii whenever they could afford it. Although his finances are stable, he wants to reduce unnecessary monthly costs before retirement. Refinancing his vehicle at a lower rate — while taking out a little extra cash for an anniversary trip — feels like a smart and rewarding move.`,
    lastUpdated: "2026-07-01",
    financialProfile: {
      demographics: {
        age: null,
        ageRange: "",
        maritalStatus: "",
        dependents: 0,
        employmentStatus: "",
        annualIncome: 72000,
        householdIncome: null,
      },
      housing: {
        isHomeOwner: true,
        isRenter: false,
        mortgage: {
          hasMortgage: false,
          balance: null,
          interestRate: null,
          monthlyPayment: null,
          yearsRemaining: null,
        },
        estimatedHomeValue: null,
        equityAmount: null,
        equityPercent: null,
        purchaseDate: null,
      },
      vehicles: {
        vehicleCount: 1,
        hasVehicleLoan: true,
        totalVehicleValue: 25000,
        totalVehicleLoanBalance: 15000,
        vehicles: [
          {
            year: null,
            make: "",
            model: "",
            estimatedValue: 25000,
            loanBalance: 15000,
            interestRate: null,
            monthlyPayment: null,
          },
        ],
      },
      banking: {
        hasChecking: false,
        hasSavings: false,
        hasMoneyMarket: false,
        hasCertificate: false,
        hasDirectDeposit: false,
        monthlyDepositAmount: null,
        averageCheckingBalance: null,
        averageSavingsBalance: null,
        overdraftCountLast12Months: 0,
      },
      credit: {
        creditScore: null,
        creditScoreRange: "",
        creditCardCount: 0,
        creditCardDebt: {
          hasDebt: false,
          totalBalance: null,
          estimatedMonthlyPayment: null,
          averageInterestRate: null,
        },
        creditUtilizationPercent: null,
      },
      loans: {
        studentLoans: {
          hasStudentLoans: false,
          balance: null,
          monthlyPayment: null,
        },
        personalLoans: {
          hasPersonalLoans: false,
          balance: null,
          monthlyPayment: null,
        },
        otherDebt: {
          balance: null,
          monthlyPayment: null,
        },
      },
      insurance: {
        hasAutoInsurance: false,
        hasHomeInsurance: false,
        hasLifeInsurance: false,
        hasUmbrellaInsurance: false,
      },
      business: {
        isBusinessOwner: false,
        hasBusinessChecking: false,
        hasMerchantServices: false,
      },
      investments: {
        hasIRA: false,
        hasRothIRA: false,
        hasBrokerageAccount: false,
        estimatedInvestableAssets: null,
      },
      education: {
        hasCollegeBoundChildren: false,
        has529Plan: false,
        tuitionPaymentsExpected: false,
      },
      lifeEvents: {
        recentlyMarried: false,
        newChild: false,
        recentHomePurchase: false,
        planningRetirement: true,
        recentJobChange: false,
        recentRelocation: false,
      },
      behavioralIndicators: {
        highSavingsGrowth: false,
        highDepositActivity: false,
        largeRecentWithdrawal: false,
        largeRecentDeposit: false,
        frequentCreditCardUsage: false,
        frequentATMUsage: false,
      },
      financialHealth: {
        debtToIncomeRatio: null,
        emergencyFundMonths: null,
        netWorthEstimate: null,
      },
    },
  },
];

const demoDefaultfinancialProfile = {
  memberId: "",
  lastUpdated: "",

  demographics: {
    age: null,
    ageRange: "",
    maritalStatus: "",
    dependents: 0,
    employmentStatus: "",
    annualIncome: null,
    householdIncome: null,
  },

  housing: {
    isHomeOwner: false,
    isRenter: false,
    mortgage: {
      hasMortgage: false,
      balance: null,
      interestRate: null,
      monthlyPayment: null,
      yearsRemaining: null,
    },
    estimatedHomeValue: null,
    equityAmount: null,
    equityPercent: null,
    purchaseDate: null,
  },

  vehicles: {
    vehicleCount: 0,
    hasVehicleLoan: false,
    totalVehicleValue: null,
    totalVehicleLoanBalance: null,
    vehicles: [
      {
        year: null,
        make: "",
        model: "",
        estimatedValue: null,
        loanBalance: null,
        interestRate: null,
        monthlyPayment: null,
      },
    ],
  },

  banking: {
    hasChecking: false,
    hasSavings: false,
    hasMoneyMarket: false,
    hasCertificate: false,
    hasDirectDeposit: false,
    monthlyDepositAmount: null,
    averageCheckingBalance: null,
    averageSavingsBalance: null,
    overdraftCountLast12Months: 0,
  },

  credit: {
    creditScore: null,
    creditScoreRange: "",
    creditCardCount: 0,
    creditCardDebt: {
      hasDebt: false,
      totalBalance: null,
      estimatedMonthlyPayment: null,
      averageInterestRate: null,
    },
    creditUtilizationPercent: null,
  },

  loans: {
    studentLoans: {
      hasStudentLoans: false,
      balance: null,
      monthlyPayment: null,
    },
    personalLoans: {
      hasPersonalLoans: false,
      balance: null,
      monthlyPayment: null,
    },
    otherDebt: {
      balance: null,
      monthlyPayment: null,
    },
  },

  insurance: {
    hasAutoInsurance: false,
    hasHomeInsurance: false,
    hasLifeInsurance: false,
    hasUmbrellaInsurance: false,
  },

  business: {
    isBusinessOwner: false,
    hasBusinessChecking: false,
    hasMerchantServices: false,
  },

  investments: {
    hasIRA: false,
    hasRothIRA: false,
    hasBrokerageAccount: false,
    estimatedInvestableAssets: null,
  },

  education: {
    hasCollegeBoundChildren: false,
    has529Plan: false,
    tuitionPaymentsExpected: false,
  },

  lifeEvents: {
    recentlyMarried: false,
    newChild: false,
    recentHomePurchase: false,
    planningRetirement: false,
    recentJobChange: false,
    recentRelocation: false,
  },

  behavioralIndicators: {
    highSavingsGrowth: false,
    highDepositActivity: false,
    largeRecentWithdrawal: false,
    largeRecentDeposit: false,
    frequentCreditCardUsage: false,
    frequentATMUsage: false,
  },

  financialHealth: {
    debtToIncomeRatio: null,
    emergencyFundMonths: null,
    netWorthEstimate: null,
  },
};

const products = [
  {
    computed: {},
    stale: [],
    id: 1,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:14.110Z",
    type: "loan",
    archived: true,
    title: "Home Equity Line of Credit (HELOC)",
    summary: "Access your home's equity for renovations, debt consolidation, or major expenses.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/heloc",
    assets: {
      cta: "Apply Now",
      hero: null,
      thumbnail: null,
      disclaimer: "Subject to credit approval",
    },
    priority: 10,
    markers: [
      { value: true, marker: "HOMEOWNER", weight: 10 },
      { value: true, marker: "HIGH_HOME_EQUITY", weight: 15 },
      { value: true, marker: "HELOC_CANDIDATE", weight: 25 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 2,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:48:43.555Z",
    type: "loan",
    archived: true,
    title: "Mortgage Refinance",
    summary: "Refinance your mortgage and potentially lower your payment.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/mortgage-refinance",
    assets: {
      cta: "Check Rates",
      hero: null,
      thumbnail: null,
      disclaimer: "Rates subject to change",
    },
    priority: 10,
    markers: [
      { value: true, marker: "HAS_MORTGAGE", weight: 15 },
      { value: true, marker: "MORTGAGE_REFINANCE_CANDIDATE", weight: 30 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 3,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "loan",
    archived: true,
    title: "First-Time Home Mortgage",
    summary: "Affordable financing options for first-time homebuyers.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/first-home",
    assets: {
      cta: "Get Started",
      hero: null,
      thumbnail: null,
      disclaimer: "Qualification requirements apply",
    },
    priority: 8,
    markers: [
      { value: true, marker: "FIRST_TIME_HOMEBUYER", weight: 35 },
      { value: true, marker: "GOOD_CREDIT", weight: 10 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 4,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "loan",
    archived: true,
    title: "Auto Loan Refinance",
    summary: "Lower your payment by refinancing your current vehicle loan.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/auto-refi",
    assets: {
      cta: "Refinance",
      hero: null,
      thumbnail: null,
      disclaimer: "Approval based on creditworthiness",
    },
    priority: 9,
    markers: [
      { value: true, marker: "HAS_AUTO_LOAN", weight: 10 },
      { value: true, marker: "HIGH_AUTO_LOAN_RATE", weight: 20 },
      { value: true, marker: "AUTO_REFINANCE_CANDIDATE", weight: 30 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 5,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "loan",
    archived: true,
    title: "New Auto Loan",
    summary: "Competitive financing for your next vehicle purchase.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/auto-loan",
    assets: {
      cta: "Apply Now",
      hero: null,
      thumbnail: null,
      disclaimer: "Vehicle eligibility applies",
    },
    priority: 7,
    markers: [
      { value: false, marker: "VEHICLE_OWNER", weight: 5 },
      { value: true, marker: "GOOD_CREDIT", weight: 10 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 6,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-24T20:30:37.859Z",
    type: "credit-card",
    archived: true,
    title: "Balance Transfer Credit Card",
    summary: "Move high-interest balances and save on interest.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/balance-transfer",
    assets: {
      cta: "Transfer Balance",
      hero: null,
      thumbnail: null,
      disclaimer: "Promotional rates may be limited",
    },
    priority: 10,
    markers: [
      { value: true, marker: "HIGH_CREDIT_CARD_DEBT", weight: 15 },
      { value: true, marker: "BALANCE_TRANSFER_CANDIDATE", weight: 25 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 7,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "loan",
    archived: true,
    title: "Debt Consolidation Loan",
    summary: "Simplify your finances with one predictable payment.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/debt-consolidation",
    assets: {
      cta: "Consolidate Debt",
      hero: null,
      thumbnail: null,
      disclaimer: "Terms and conditions apply",
    },
    priority: 10,
    markers: [{ value: true, marker: "DEBT_CONSOLIDATION_CANDIDATE", weight: 35 }],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 8,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "checking",
    archived: true,
    title: "Rewards Checking Account",
    summary: "Earn rewards while enjoying convenient everyday banking.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/rewards-checking",
    assets: {
      cta: "Open Account",
      hero: null,
      thumbnail: null,
      disclaimer: "Membership eligibility required",
    },
    priority: 8,
    markers: [
      { value: false, marker: "HAS_CHECKING", weight: 30 },
      { value: false, marker: "HAS_DIRECT_DEPOSIT", weight: 10 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 9,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "savings",
    archived: true,
    title: "High Yield Savings Account",
    summary: "Build your savings faster with competitive dividend rates.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/high-yield-savings",
    assets: {
      cta: "Start Saving",
      hero: null,
      thumbnail: null,
      disclaimer: "Dividend rates may change at any time",
    },
    priority: 7,
    markers: [
      { value: false, marker: "HAS_SAVINGS", weight: 30 },
      { value: true, marker: "HIGH_SAVINGS_GROWTH", weight: 10 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 10,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "deposit",
    archived: true,
    title: "Money Market Account",
    summary: "Earn more on larger balances while keeping access to your funds.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/money-market",
    assets: {
      cta: "Learn More",
      hero: null,
      thumbnail: null,
      disclaimer: "Minimum balance requirements may apply",
    },
    priority: 6,
    markers: [
      { value: true, marker: "HAS_SAVINGS", weight: 10 },
      { value: true, marker: "HIGH_DEPOSIT_ACTIVITY", weight: 20 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 11,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "certificate",
    archived: true,
    title: "Certificate of Deposit",
    summary: "Lock in competitive returns with fixed-term savings.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/certificate",
    assets: {
      cta: "View Rates",
      hero: null,
      thumbnail: null,
      disclaimer: "Early withdrawal penalties may apply",
    },
    priority: 5,
    markers: [
      { value: true, marker: "HAS_SAVINGS", weight: 10 },
      { value: true, marker: "HIGH_DEPOSIT_ACTIVITY", weight: 15 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 12,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "credit-card",
    archived: true,
    title: "Cash Back Rewards Credit Card",
    summary: "Earn cash back on your everyday purchases.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/cash-back-card",
    assets: {
      cta: "Apply Now",
      hero: null,
      thumbnail: null,
      disclaimer: "Subject to credit approval",
    },
    priority: 8,
    markers: [
      { value: true, marker: "GOOD_CREDIT", weight: 15 },
      { value: true, marker: "FREQUENT_CREDIT_CARD_USAGE", weight: 20 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 13,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "credit-card",
    archived: true,
    title: "Low Rate Credit Card",
    summary: "Enjoy a lower interest rate for everyday borrowing.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/low-rate-card",
    assets: {
      cta: "Apply Today",
      hero: null,
      thumbnail: null,
      disclaimer: "Rates vary based on credit qualifications",
    },
    priority: 7,
    markers: [
      { value: true, marker: "HAS_CREDIT_CARD_DEBT", weight: 15 },
      { value: true, marker: "GOOD_CREDIT", weight: 10 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 14,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "credit-card",
    archived: true,
    title: "Secured Credit Builder Card",
    summary: "Establish or rebuild your credit history responsibly.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/secured-card",
    assets: {
      cta: "Build Credit",
      hero: null,
      thumbnail: null,
      disclaimer: "Security deposit required",
    },
    priority: 8,
    markers: [{ value: true, marker: "CREDIT_BUILDER_CANDIDATE", weight: 35 }],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 15,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "loan",
    archived: true,
    title: "Personal Loan",
    summary: "Flexible financing for vacations, emergencies, and major purchases.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/personal-loan",
    assets: { cta: "Apply Now", hero: null, thumbnail: null, disclaimer: "Loan approval required" },
    priority: 7,
    markers: [
      { value: true, marker: "GOOD_CREDIT", weight: 10 },
      { value: true, marker: "HIGH_CREDIT_UTILIZATION", weight: 20 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 16,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "loan",
    archived: true,
    title: "Credit Builder Loan",
    summary: "Improve your credit through consistent payments.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/credit-builder-loan",
    assets: { cta: "Start Building", hero: null, thumbnail: null, disclaimer: "Terms apply" },
    priority: 8,
    markers: [
      { value: true, marker: "CREDIT_BUILDER_CANDIDATE", weight: 30 },
      { value: true, marker: "POOR_CREDIT", weight: 20 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 17,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "retirement",
    archived: true,
    title: "Traditional IRA",
    summary: "Save for retirement with tax-advantaged retirement accounts.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/traditional-ira",
    assets: {
      cta: "Start Saving",
      hero: null,
      thumbnail: null,
      disclaimer: "Consult a tax advisor regarding eligibility and tax benefits",
    },
    priority: 8,
    markers: [
      { value: false, marker: "HAS_RETIREMENT_ACCOUNT", weight: 20 },
      { value: true, marker: "RETIREMENT_SAVINGS_OPPORTUNITY", weight: 30 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 18,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "retirement",
    archived: true,
    title: "Roth IRA",
    summary: "Build tax-free retirement income for your future.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/roth-ira",
    assets: {
      cta: "Open Roth IRA",
      hero: null,
      thumbnail: null,
      disclaimer: "Income limits and IRS rules may apply",
    },
    priority: 8,
    markers: [
      { value: false, marker: "HAS_ROTH_IRA", weight: 15 },
      { value: true, marker: "RETIREMENT_SAVINGS_OPPORTUNITY", weight: 25 },
      { value: true, marker: "GOOD_CREDIT", weight: 5 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 19,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-18T17:38:24.131Z",
    type: "investment",
    archived: true,
    title: "Investment Advisory Services",
    summary: "Work with a financial advisor to create a personalized investment strategy.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "https://www.example.com/products/investment-advisory",
    assets: {
      cta: "Meet an Advisor",
      hero: null,
      thumbnail: null,
      disclaimer: "Investment products are not federally insured and may lose value",
    },
    priority: 7,
    markers: [
      { value: true, marker: "HIGH_INVESTABLE_ASSETS", weight: 25 },
      { value: true, marker: "WEALTH_MANAGEMENT_CANDIDATE", weight: 30 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 20,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "investment",
    archived: true,
    title: "Financial Planning Services",
    summary: "Create a comprehensive strategy for retirement, savings, insurance, and investments.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/financial-planning",
    assets: {
      cta: "Schedule Consultation",
      hero: null,
      thumbnail: null,
      disclaimer: "Financial planning services may involve fees",
    },
    priority: 6,
    markers: [
      { value: true, marker: "APPROACHING_RETIREMENT", weight: 20 },
      { value: true, marker: "HIGH_INVESTABLE_ASSETS", weight: 15 },
      { value: true, marker: "HAS_DEPENDENTS", weight: 10 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 21,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "education",
    archived: true,
    title: "529 College Savings Plan",
    summary: "Save today for future education expenses with potential tax advantages.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/529-plan",
    assets: {
      cta: "Start a 529 Plan",
      hero: null,
      thumbnail: null,
      disclaimer: "Consult your financial advisor before investing",
    },
    priority: 7,
    markers: [
      { value: true, marker: "COLLEGE_BOUND_CHILDREN", weight: 25 },
      { value: true, marker: "COLLEGE_SAVINGS_OPPORTUNITY", weight: 30 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 22,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "insurance",
    archived: true,
    title: "Life Insurance",
    summary: "Protect your family's financial future with affordable life insurance coverage.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/life-insurance",
    assets: {
      cta: "Get a Quote",
      hero: null,
      thumbnail: null,
      disclaimer: "Coverage subject to underwriting approval",
    },
    priority: 7,
    markers: [
      { value: true, marker: "NEW_PARENT", weight: 25 },
      { value: true, marker: "HOMEOWNER", weight: 5 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 23,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "insurance",
    archived: true,
    title: "Umbrella Insurance",
    summary: "Add an extra layer of liability protection above your existing policies.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/umbrella-insurance",
    assets: {
      cta: "Learn More",
      hero: null,
      thumbnail: null,
      disclaimer: "Coverage availability varies by state",
    },
    priority: 5,
    markers: [
      { value: true, marker: "HOMEOWNER", weight: 10 },
      { value: true, marker: "HIGH_INVESTABLE_ASSETS", weight: 15 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 24,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "business",
    archived: true,
    title: "Business Checking Account",
    summary: "Manage your business finances with a dedicated business checking account.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/business-checking",
    assets: {
      cta: "Open Business Account",
      hero: null,
      thumbnail: null,
      disclaimer: "Business documentation required",
    },
    priority: 8,
    markers: [
      { value: true, marker: "BUSINESS_OWNER", weight: 20 },
      { value: false, marker: "HAS_BUSINESS_CHECKING", weight: 25 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 25,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "business",
    archived: true,
    title: "Small Business Loan",
    summary: "Finance equipment, expansion, or working capital needs for your business.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/business-loan",
    assets: {
      cta: "Apply for Financing",
      hero: null,
      thumbnail: null,
      disclaimer: "Approval based on business qualifications",
    },
    priority: 9,
    markers: [
      { value: true, marker: "BUSINESS_OWNER", weight: 15 },
      { value: true, marker: "BUSINESS_LENDING_CANDIDATE", weight: 35 },
    ],
    audience: 0,
    engaged: 0,
  },
  {
    computed: {},
    stale: [],
    id: 26,
    createdAt: "2026-06-10T23:07:44.277Z",
    updatedAt: "2026-06-12T18:25:31.692Z",
    type: "business",
    archived: true,
    title: "Merchant Services",
    summary: "Accept payments and streamline your business operations.",
    startDate: "2026-06-10T23:07:44.277Z",
    endDate: null,
    url: "/products/merchant-services",
    assets: {
      cta: "Get Started",
      hero: null,
      thumbnail: null,
      disclaimer: "Service terms and processing fees apply",
    },
    priority: 6,
    markers: [
      { value: true, marker: "BUSINESS_OWNER", weight: 15 },
      { value: false, marker: "HAS_MERCHANT_SERVICES", weight: 25 },
    ],
    audience: 0,
    engaged: 0,
  },
];

const theExports = {
  demoUserProfiles,
  products,
};

export default theExports;
